var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"vue-component"},[_c('label',[_vm._v(_vm._s(_vm.node.attrs.option_name))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('input',{attrs:{"model":_vm.node.attrs.option_value,"placeholder":_vm.node.attrs.option_name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }